export default {
      id: "button-facebook-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#button-facebook",
      toString: function () {
        return this.url;
      }
    }